<template>
    <div class="product-list">
        <div class="bg">
            <img :src="imgUrl" alt="">
        </div>
        <div class="list-width">
            <div class="search-bar">
                <Row :gutter="0" justify="center">
                    <Col span="13" class="hot">
                        <strong>热门搜索：</strong>
                        <a v-for="item in words" @click="search">
                            {{item.word}}&nbsp;&nbsp;
                        </a>
                    </Col>
                    <Col span="9" style="padding-right: 5px">
                        <Input>
                            <Icon type="ios-search" slot="prefix" />
                        </Input>
                    </Col>
                    <Col span="2">
                        <Button type="error" long @click="search">搜索</Button>
                    </Col>
                </Row>
            </div>

            <div class="product-details">
                <!-- swiper1 -->
                <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop" v-if="images.length != 0">
                    <swiper-slide v-for="(item, index) in images">
                        <img :src="item.url" alt="">
                    </swiper-slide>
                    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                </swiper>
                <br>
                <!-- swiper2 Thumbs -->
                <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs"  v-if="images.length != 0">
                    <swiper-slide  v-for="(item, index) in images">
                        <img class="sub" :src="item.url" alt="">
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
    import * as product from '@/controller/product'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        name: "more",
        components: {
            swiper, swiperSlide
        },
        data() {
            return {
                searchValue: '',
                classify: '',
                details: '',
                imageType: [],
                images:[],
                words: '',
                imgUrl: '',
                swiperOptionTop: {
                    spaceBetween: 0,
                    loop: true,
                    loopedSlides: 5, //looped slides should be the same
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                swiperOptionThumbs: {
                    spaceBetween: 10,
                    slidesPerView: 3,
                    touchRatio: 0.2,
                    loop: true,
                    loopedSlides: 5, //looped slides should be the same
                    slideToClickedSlide: true,
                }
            }
        },
        mounted() {
            if(this.$route.params.images) {
                console.log(this.$route.params.images)
                this.images = this.$route.params.images
            }else {
                this.$router.push({ name: 'product-list'})
            }
            this.hotWords()
            this.showBanner()


            this.$nextTick(() => {
                const swiperTop = this.$refs.swiperTop.swiper
                const swiperThumbs = this.$refs.swiperThumbs.swiper
                swiperTop.controller.control = swiperThumbs
                swiperThumbs.controller.control = swiperTop
            })
        },
        methods: {
            //显示banner图
            showBanner() {
                product.fetchBanner()
                    .then(result => {
                        this.imgUrl = result.imgUrl.product
                    })
            },
            //搜索
            search() {
                this.$router.push({ name: 'product-list'})
            },
            //热词
            hotWords() {
                product.fetchHotWords()
                    .then(result => {
                        this.words = result.list
                    })
            }
        }
    }
</script>

<style scoped lang="stylus">
    .product-list
        background-color #F5F5F5
        .bg
            background-color #EAEAEA
            height 100px
            overflow hidden
            z-index 1
        .list-width
            width 1000px
            margin 0 auto
            position relative
            top -20px
            z-index 9
            .search-bar
                background-color #B5B5B5
                padding 3px
                i
                    color #DB1232
                    font-size 18px
                input
                    width 100%
                    height 32px
                    outline none
                    border none
                .hot
                    text-align left
                    padding-top 7px
                    padding-left 15px
                    a
                        color white
            .product-details
                margin 30px auto
                img
                    display block
                    width 100%
                    height 500px
                    background-color gray
                .sub
                    height 100px
    .gallery-thumbs
        height: 20%!important
        box-sizing: border-box
        padding: 10px 0
    .gallery-thumbs .swiper-slide
        width: 25%
        height: 100%
        opacity: 0.4
    .gallery-thumbs .swiper-slide-active
        opacity: 1


</style>